import React, { Component } from 'react';
import './Footer.scss'
import { Link, Switch, Route } from 'react-router-dom'
import axios from 'axios'
let api = axios.create({
    baseURL: '/'
});
if (process.env.NODE_ENV === 'development') {
    api = axios.create({
        baseURL: 'http://localhost/'
    });
}

class Footer extends Component {

	
	render() {
		return (
			<div id="footer" className="footer">
				<Switch>
					<Route path="/what-weve-done"  />
					<Route path="/blog" />
					<Route path="/the-moshi-difference" />
					<Route path="/contact-us"  />
					<Route component={RecentWork} />
				</Switch>
				<Contact />
				<Copyright />
			</div>
		);
	}
}

const Circle = ({ title, image, className }) =>
		<div className={`recent-circle-holder ${className}`}>
		<div className="recent-circle" style={{ backgroundImage: `url(${image})`}} />
			<div className="recent-circle-title">
				{ title || "Bunbury RSL Sub-Branch"}
			</div>
	</div>
		
		
class Contact extends Component {
	state = {
		name: "",
		email: "",
		phone: "",
		message: "",
		form: "",
		status: 0,
		recaptcha: "",
		validation: false,
	}

	componentDidMount() {
		setTimeout(() => {
			const script = document.createElement("script");
			script.src = "https://apis.google.com/js/platform.js";
			document.body.appendChild(script)
		}, 1500);
	}

		submitForm = (e) => {
			e.preventDefault();
			if (this.state.name && this.state.phone) {
				this.setState({ status: 1 })
				var params = new URLSearchParams()
				params.append('name', this.state.name);
				params.append('email', this.state.email);
				params.append('phone', this.state.phone);
				params.append('message', this.state.message);
				api
				  .post('/form.php', params )
					.then(({ data }) => { console.log(data); this.setState({ status: 2 }); this.setState({ form: data }) })
					
					.catch(err => {
						this.setState({ status: 0 })
						this.setState({ validation: true, })
					})
				
				this.setState({ validation: false, })
			} else {
				this.setState({ validation: true, })
		  }
	  }
	
			render() {
				return (
					<div className="contact">
<div className="container-fluid">
	<div className="row align-items-end">
		<div className="col-xl-1"></div>
		<div className="col-xl-6">
			<div className="social-icons">
				<a href="https://www.facebook.com/StartWithMoshi/"><i className="fa fa-facebook-square fa-2x"></i></a>
				<a href="https://twitter.com/wearemoshi"><i className="fa fa-twitter-square fa-2x"></i></a>
				<a href="https://www.linkedin.com/company/moshi-moshi-marketing/"><i className="fa fa-linkedin-square fa-2x"></i></a>
			</div>
			<h2>Want to know more? <strong>Let's chat!</strong></h2>
			<form className="contact-form-holder" onSubmit={this.submitForm}>
										<div className="row">
											<div className="col-md-12">
												{this.state.status === 1 && <label className="alert alert-warning ">Loading Form Submittion...</label>}
												{this.state.status === 2 && <label className="alert alert-success ">Thank you for your enquiry</label>}
											</div>
											<div className="col-md-6">
												{this.state.status === 0 && <div>
													{this.state.validation ? <label className="alert alert-danger small">Please fill out all the details before submitting.</label> : null}
													<div><input type="text" className="form-control" placeholder="Name" name="name" onChange={e => this.setState({ name: e.target.value })} /></div>
													<div><input type="text" className="form-control" placeholder="Email" name="email" onChange={e => this.setState({ email: e.target.value })} /></div>
													<div><input type="text" className="form-control" placeholder="Phone" name="phone" onChange={e => this.setState({ phone: e.target.value })} /></div>
												</div>}
					</div>
											<div className="col-md-6">
												{this.state.status === 0 && <div>
													<textarea id="" cols="30" rows="4" className="form-control" placeholder="Message" onChange={e => this.setState({ message: e.target.value })} ></textarea>
													<input type="submit" value="Submit" /></div>}
													
												
					</div>
				</div>
			</form>
		</div>
		
<div className="col-xl-4">
		
			<ul className="contact-details">	
						
				<li><strong>Perth and Bunbury</strong></li>
				<li><i className="fa fa-phone-square fa-fw"></i><a href="tel:0480333393">0480 333 393</a></li>
				<li><i className="fa fa-file fa-fw"></i><a href="mailto:hello@moshi.com.au">hello@moshi.com.au</a></li>
		</ul>
		</div>



	</div>
</div>
	</div>
				);
			}
		}
		
	



const Copyright = () =>
<div className="copyright">
<div className="container-fluid">
	<div className="row">
		<div className="col-lg-1"></div>
		<div className="col-lg-6"></div>
		<div className="col-lg-2">
		ABN 38 605 208 446<br/>@ Moshi Moshi Marketing | <Link to="/privacy-policy">Privacy</Link> | <Link to="/terms-of-use">Terms </Link>
		</div>
		<div className="col-lg-2">
			<div className="g-partnersbadge" data-agency-id="4651240890" width="165" height="61"></div>
		</div>
		<div className="col-lg-1"></div>
	</div>
</div>
	</div>

const RecentWork = () =>
	<div className="recent-work">
	<div className="container-fluid">
		<div className="row align-items-end">
			<div className="col-xl-4">
				<Link to="/what-weve-done/bunbury-central"><Circle
					className="large"
					image={require('../Media/bunbury_central.jpg')}
						title="Bunbury Central" />
						</Link>
			</div>
			<div className="col-xl-8">
				<h2>
					<span>designed, developed and delivered:</span>
					<div>successful brand engagement</div>
				</h2>
				<div className="row">
					
					<div className="col-md-3 col-sm-6">
							<Link to="/what-weve-done/churchview">
								<Circle
								image={require('../Media/churchview_home.jpg')}
										title="Churchview Estate" />
							</Link>
					</div>
						<div className="col-md-3 col-sm-6">
						<Link to="/what-weve-done/harley-dykstra">
						<Circle
							image={require('../Media/harley_dykstra_home.jpg')}
									title="Harley Dykstra" />
								</Link>
					</div>
						<div className="col-md-3 col-sm-6">
						<Link to="/what-weve-done/bunbury-turf-club">
						<Circle
							image={require('../Media/bunbury_turf_club.jpg')}
									title="Bunbury Turf Club" />
								</Link>
					</div>
						<div className="col-md-3 col-sm-6">
						<Link to="/what-weve-done/prince-hotel">
						<Circle
							image={require('../Media/prince_hotel_home.jpg')}
									title="Prince of Wales Hotel" />
								</Link>
					</div>

				</div>
			</div>
		</div>
	</div>
	</div>

export default Footer;


// WEBPACK FOOTER //
// ./src/Layout/Footer.js